import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import {
  Observable,
  Subject
} from 'rxjs';

import { FlipperSidesModel }             from '../shared/components/flipper/typings/flipper.sides';
import { HaynesProLaborTimeModel }       from './typings/haynes-pro.labor-time';
import { HaynesProRecordTypeModel }      from './typings/haynes-pro.record-type';
import { HaynesProRepairSubjectModel }   from './typings/haynes-pro.repair-subject';
import { HaynesProService }              from './haynes-pro.service';
import { HaynesProServiceIntervalModel } from './typings/haynes-pro.service-interval';
import { HaynesProVehicleInfoModel }     from './typings/haynes-pro.vehicle-info';
import { JsonService }                   from '../core/services/json.service';
import { MessagesService }               from '../messages/messages.service';
import { VehicleModel }                  from '../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-add-labor-times',
  template: require('./haynes-pro.add-labor-times.component.html')
})
export class HaynesProAddLaborTimesComponent implements OnInit {
  public activeSide       : FlipperSidesModel                    = 'front';
  public activeTab        : 1 | 2                                = 1;
  public laborTimeRemoved$: Subject<HaynesProLaborTimeModel>     = new Subject<HaynesProLaborTimeModel>();
  public laborTimeRemoved : Observable<HaynesProLaborTimeModel>  = this.laborTimeRemoved$.asObservable();
  public laborTimes       : Array<HaynesProLaborTimeModel>       = [];
  public repairSubjects   : Array<HaynesProRepairSubjectModel>   = [];
  public serviceIntervals : Array<HaynesProServiceIntervalModel> = [];

  @BlockUI('haynesProAddLaborTimesBackBlock') backBlock   : NgBlockUI;
  @BlockUI('haynesProAddLaborTimesFrontBlock') frontBlock : NgBlockUI;

  @Input() recordId: string;
  @Input() type    : HaynesProRecordTypeModel;
  @Input() variants: Array<HaynesProVehicleInfoModel>
  @Input() vehicle : VehicleModel;

  constructor (
    public activeModal       : NgbActiveModal,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    private jsonService      : JsonService,
    private messagesService  : MessagesService
  ) {}

  ngOnInit () : void {
    this.init();
  }

  addLaborTime ( time : HaynesProLaborTimeModel ) : void {
    const copy = this.jsonService.copy(time);

    copy.added = true;

    this.laborTimes.push(copy);
  }

  changeSide ( side : FlipperSidesModel = 'back' ) : void {
    this.activeSide = side;

    this.changeDetectorRef.detectChanges();
  }

  checkout () : void {
    this.backBlock.start();

    this.haynesProService.saveLaborTimes(this.type, this.recordId, this.vehicle, this.laborTimes)
    .then(( times : Array<HaynesProLaborTimeModel> ) => {
      this.activeModal.close(times);
    })
    .finally(() => {
      this.backBlock.stop();
    });
  }

  clearLaborTimes () : void {
    if (!this.laborTimes?.length) {
      return;
    }

    this.laborTimes.forEach(( time : HaynesProLaborTimeModel ) => this.removeLaborTime(time));

    this.laborTimes = [];
  }

  init () : void {
    this.frontBlock.start();

    this.haynesProService.getServiceIntervals(this.vehicle)
    .then(( intervals : Array<HaynesProServiceIntervalModel> ) => {
      this.serviceIntervals = intervals;

      return this.haynesProService.getRepairSubjects(this.vehicle);
    })
    .then(( subjects : Array<HaynesProRepairSubjectModel> ) => {
      this.repairSubjects = subjects;
    })
    .catch(err => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.frontBlock.stop();
    });
  }

  removeLaborTime ( time : HaynesProLaborTimeModel ) : void {
    this.laborTimes = this.laborTimes.filter(item => {
      return item.subgroup_id !== time.subgroup_id
        && item.name !== time.name;
    });

    this.laborTimeRemoved$.next(time);
  }

  switchVariant () : void {
    this.haynesProService.selectVehicleVariant(this.vehicle, this.variants)
    .then(( vehicle : VehicleModel ) => {
      this.vehicle = vehicle;

      this.clearLaborTimes();
      this.init();
    });
  }

  viewCart () : void {
    this.changeSide('back');
  }
}
